import { useContext, useState } from "react";
import DropdownCore from "./components/DropdownCore";
import DropdownItem from "./components/DropdownItem";
import { BsShare } from "react-icons/bs";
import { MdSaveAlt } from "react-icons/md";
import modalContext from "../../../dataManager/context/modalContext";
import { saveProduct } from "../../../../src/api/users/usersApi";
import currentAdminContext from "../../../dataManager/context/currentAdminContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ProductDropdownUser = ({ productId, onChangeLoading }) => {
  //context variables
  const { currentAdmin } = useContext(currentAdminContext);
  const { handleOpenModal } = useContext(modalContext);

  //state variables
  const [error, setError] = useState(false);

  const navigate = useNavigate();

  const handleSaveProduct = async () => {
    // if user is no yet logged redirect to login page
    if (!currentAdmin || currentAdmin.getId === 0) {
      return navigate("/connexion/user");
    }

    onChangeLoading(true);
    setError("");
    try {
      const { data } = await saveProduct(currentAdmin, productId);

      if (data) {
        toast.success("L'article a été enregistré, vérifier votre profile", {
          theme: "colored",
        });
        setError("");
        return onChangeLoading(false);
      }

      toast.info("Cet article est déjà enregistré sur votre profile", {
        theme: "colored",
      });
      setError("");
      return onChangeLoading(false);
    } catch (error) {
      setError(error);
      onChangeLoading(false);
    }
  };

  return (
    <DropdownCore>
      <DropdownItem
        icon={<MdSaveAlt size={17} />}
        title="Enregistrer"
        onClick={handleSaveProduct}
      />

      <DropdownItem
        icon={<BsShare size={15} />}
        title="Partager"
        onClick={() =>
          handleOpenModal("SHARE_PRODUCT", "Partager cet article", {
            productId,
          })
        }
      />
    </DropdownCore>
  );
};

export default ProductDropdownUser;
